import { Employee } from '@akiba/models_bimbo';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppState } from '../../../models/appState';
import { Subscription } from 'rxjs';
import { LogicService } from '../../../services/logic.service';
import { ActivatedRoute } from '@angular/router';
import { MatTabChangeEvent } from '@angular/material';
import { environment } from 'projects/bimbo/src/environments/environment';

@Component({
  selector: 'app-employee-profile',
  templateUrl: './employee-profile.component.html',
  styleUrls: ['./employee-profile.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmployeeProfileComponent implements OnInit, OnDestroy {

  principalSubscription: Subscription;

  contentLocation: AppState = new AppState();
  appLoginSubscription: Subscription;
  employeeNumber: string;
  employeeInfo = '';

  general: string;
  laboral: string;

  currentEmployee: Employee;


  constructor(public logicService: LogicService, private route: ActivatedRoute) {

    this.general = environment.images.states.selected.general;
    this.laboral = environment.images.states.unselected.laboral;

    if (this.logicService.dataManager.proxyDataLoader.employee) {
      this.currentEmployee = this.logicService.dataManager.proxyDataLoader.employee;
    } else {
      this.currentEmployee = this.logicService.dataManager.principalDataLoader.employee;
    }

    const employeeInfoToShow = this.currentEmployee ? 'Colaborador ' + this.currentEmployee.workInformation.employeeNumber + ' - ' + this.currentEmployee.displayName : 'Cargando Información ...';
    this.employeeInfo = employeeInfoToShow;

  }

  ngOnInit() {
  }

  tabChanged(event: MatTabChangeEvent): void {

    this.contentLocation.tabIndex = event.index;
    this.contentLocation.detailIndex = 0;

    this.general = environment.images.states.unselected.general;
    this.laboral = environment.images.states.unselected.laboral;

    if (event.index === 0) {
      this.general = environment.images.states.selected.general;
    } else if (event.index === 1) {
      this.laboral = environment.images.states.selected.laboral;
    } else if (event.index === 2) {
    }

  }

  subTabChange(event: MatTabChangeEvent): void {
    this.contentLocation.detailIndex = event.index;
  }

  ngOnDestroy(): void {

    if (this.appLoginSubscription && !this.appLoginSubscription.closed) {
      this.appLoginSubscription.unsubscribe();
      this.appLoginSubscription = null;
    }

  }

}
